document.addEventListener('DOMContentLoaded', () => {
    const loadingScreen = document.getElementById('loading-screen');
    const loadingText = document.getElementById('loading-text');
    const texts = ["Loading experience", "Hold on", "Almost there"];
    let textIndex = 0;
  
    // Change text every 3 seconds
    const textInterval = setInterval(() => {
      textIndex = (textIndex + 1) % texts.length;
      loadingText.textContent = texts[textIndex];
    }, 3000);
  
    // A-Frame and MindAR scene
    const scene = document.querySelector('a-scene');
  
    // Handle AR Ready event
    scene.addEventListener('arReady', () => {
      console.log('MindAR is ready');
      clearInterval(textInterval); // Stop text change interval
      loadingScreen.style.display = 'none'; // Hide custom loading screen
  
      // Show the camera feed
      const cameraFeed = document.querySelector('video');
      if (cameraFeed) {
        cameraFeed.style.display = 'block';
      }
    });
  
    // Handle AR Error event
    scene.addEventListener('arError', (error) => {
      console.error('AR Error:', error);
      loadingText.textContent = 'Failed to load AR experience.';
    });
  });
  